import { Cell, ClickableIcon, IconEditFilled, useStack } from '@direct-frontend/components';
import { useToggle } from '@direct-frontend/stdlib';
import { SettingsBlockRow } from '#shared/components/SettingsBlockRow';
import { EMPTY_DASH } from '#shared/lib/constants';
import { INTEGRATION_TYPE_1C, type ReactFeatureComponent } from '#shared/lib/integrations';
import { IntegrationMappingModal, useIntegrationMappingDisplayLabels } from '../../../IntegrationMapping';

export const InventoryFeatureCompareParametersRowContent: ReactFeatureComponent = ({
    feature,
    'data-testid': dataTestId = 'CompareParametersRow',
}) => {
    const {
        value: isOpenCompareParametersModal,
        toggleOn: openCompareParametersModal,
        toggleOff: closeCompareParametersModal,
    } = useToggle(false);
    const mappingDisplayLabels = useIntegrationMappingDisplayLabels({ integration_type: INTEGRATION_TYPE_1C });

    const alignStart = useStack({
        alignItems: 'flex-start',
    });

    return (
        <>
            <SettingsBlockRow
                id={feature}
                title="Сопоставлять по"
                content={{ title: mappingDisplayLabels || EMPTY_DASH }}
                data-testid={dataTestId}
            >
                <Cell type="Icon" className={alignStart}>
                    <ClickableIcon onClick={openCompareParametersModal} data-testid={`${dataTestId}.Button`}>
                        <IconEditFilled size="20" />
                    </ClickableIcon>
                </Cell>
            </SettingsBlockRow>
            <IntegrationMappingModal
                size="overlay-small"
                isOpen={isOpenCompareParametersModal}
                onClose={closeCompareParametersModal}
                source={INTEGRATION_TYPE_1C}
                title="Параметры сопоставления товаров"
                caption={`Изменения применятся ко всем выгрузкам из ${INTEGRATION_TYPE_1C}`}
                label="Товары из разных источников сопоставляются по параметрам:"
            />
        </>
    );
};
